import React, { isValidElement } from "react";
import { Trans } from "react-i18next";

const LOCALIZABLE_NAMESPACE = 'localizable';

function wrapWithKey(element: React.ReactNode, key: React.Key) {
  if (isValidElement(element)) {
    return React.cloneElement(element, { key });
  }
  return <React.Fragment key={key}>{element}</React.Fragment>;
}

function translateString(str: string, namespace: string): React.ReactNode {
  return str.trim() === "" ? str : <Trans i18nKey={str.trim()} ns={namespace} />;
}

export function translateReactNode(node: React.ReactNode, namespace: string = LOCALIZABLE_NAMESPACE): React.ReactNode {
  if (node == null || typeof node === "boolean") return node;

  if (typeof node === "string") return translateString(node, namespace);

  if (Array.isArray(node)) {
    return node.map((child, idx) => wrapWithKey(translateReactNode(child, namespace), idx));
  }

  if (isValidElement(node)) {
    const { children, ...props } = node.props;

    const translatedChildren = React.Children.map(children, child =>
      translateReactNode(child, namespace)
    );

    return React.cloneElement(node, props, translatedChildren);
  }

  return node;
}
